import React from "react"
import {graphql, useStaticQuery} from "gatsby"

import teamBoxStyles from './team_box_sort.module.scss'
import SortableTable from "./Table/table"
import TopTableBar from "./Table/Extras/top_bar"
import teamStyles from './Table/Tables/qb_table.module.scss'



const TeamBoxSort = () => {

    // temp fillers for testing //
    const tempFields = [
        {
            'displayName' : 'nfelo',
            'refName' : 'nfelo',
            'fieldGroup' : 'nfelo',
            'displayType' : 'unstyled',
            'displayParams' : {},
        },
        {
            'displayName' : 'QB Adj',
            'refName' : '_538_qb_adj',
            'fieldGroup' : 'nfelo',
            'displayType' : 'QBAdj',
            'displayParams' : {},
        },
        {
            'displayName' : 'Spread Value',
            'refName' : 'spread_val',
            'fieldGroup' : 'Spread Value',
            'displayType' : 'unstyled',
            'displayParams' : {},
        },
        {
            'displayName' : 'WoW',
            'refName' : 'wow_spread_val',
            'fieldGroup' : 'Spread Value',
            'displayType' : 'SpreadChange',
            'displayParams' : {
                'measureType' : 'week',
                'rem' : '0.8rem'
            },
        },
        {
            'displayName' : 'YTD',
            'refName' : 'soy_spread_val',
            'fieldGroup' : 'Spread Value',
            'displayType' : 'SpreadChange',
            'displayParams' : {
                'measureType' : 'season',
                'rem' : '0.8rem'
            },
        },
        {
            'displayName' : 'Actual',
            'refName' : 'wins',
            'fieldGroup' : 'Wins',
            'displayType' : 'Wins',
            'displayParams' : {},
        },
        {
            'displayName' : 'Pythag',
            'refName' : 'pythag_wins',
            'fieldGroup' : 'Wins',
            'displayType' : 'Wins',
            'displayParams' : {},
        },
        {
            'displayName' : 'PFF',
            'refName' : 'expected_wins_pff_ytd',
            'fieldGroup' : 'Wins',
            'displayType' : 'Wins',
            'displayParams' : {},
        },
        {
            'displayName' : '538',
            'refName' : 'expected_wins_538_ytd',
            'fieldGroup' : 'Wins',
            'displayType' : 'Wins',
            'displayParams' : {},
        },
        {
            'displayName' : 'For',
            'refName' : 'points_for_ytd',
            'fieldGroup' : 'Points',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Against',
            'refName' : 'points_against_ytd',
            'fieldGroup' : 'Points',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Net',
            'refName' : 'point_dif_ytd',
            'fieldGroup' : 'Points',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : '/ Play',
            'refName' : 'epa_per_play_ytd',
            'fieldGroup' : 'Offensive EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {
                'percision' : 2,
            },
        },
        {
            'displayName' : '/ Pass',
            'refName' : 'epa_per_pass_ytd',
            'fieldGroup' : 'Offensive EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {
                'percision' : 2,
            },
        },
        {
            'displayName' : '/ Rush',
            'refName' : 'epa_per_rush_ytd',
            'fieldGroup' : 'Offensive EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {
                'percision' : 2,
            },
        },
        {
            'displayName' : '/ Play',
            'refName' : 'epa_per_play_against_ytd',
            'fieldGroup' : 'Defensive EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {
                'percision' : 2,
            },
        },
        {
            'displayName' : '/ Pass',
            'refName' : 'epa_per_pass_against_ytd',
            'fieldGroup' : 'Defensive EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {
                'percision' : 2,
            },
        },
        {
            'displayName' : '/ Rush',
            'refName' : 'epa_per_rush_against_ytd',
            'fieldGroup' : 'Defensive EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {
                'percision' : 2,
            },
        },
        {
            'displayName' : '/ Play',
            'refName' : 'net_epa_per_play_ytd',
            'fieldGroup' : 'Net EPA',
            'displayType' : 'AsFloat',
            'displayParams' : {
                'percision' : 2,
            },
        },
    ]

    const defaultSort = [{
        'field' : 'nfelo',
        'direction' : 'dsc'
    }]


    // data //
    const data = useStaticQuery(graphql`
        query {
            allCurrentElosCsv {
            nodes {
                elo_rank
                wow_rank_change
                team_nick
                team_logo_espn
                team
                team_color
                nfelo
                _538_qb_adj
                spread_val
                wow_spread_val
                soy_spread_val
                elo_rank
                wow_rank_change
                soy_rank_change
                wins
                points_for_ytd
                points_against_ytd
                point_dif_ytd
                film_dif_ytd
                epa_per_play_ytd
                epa_per_pass_ytd
                epa_per_rush_ytd
                epa_per_play_against_ytd
                epa_per_pass_against_ytd
                epa_per_rush_against_ytd
                net_epa_per_play_ytd
                wepa_margin_ytd
                wepa_for_ytd
                wepa_against_ytd
                expected_wins_538_ytd
                expected_wins_pff_ytd
                qb_value_538_ytd
                pythag_wins
                nfelo_rank
                point_dif_ytd_rank
                net_epa_per_play_ytd_rank
                epa_per_play_ytd_rank
                epa_per_pass_ytd_rank
                epa_per_rush_ytd_rank
                epa_per_play_against_ytd_rank
                epa_per_pass_against_ytd_rank
                epa_per_rush_against_ytd_rank
                season
                week
            }
            }
        }      
    `)

    return (

        <div className={teamBoxStyles.team_container}>
            <TopTableBar
                tableData={data.allCurrentElosCsv.nodes}
                ignores={[]}
                fileName={'nfelo-power-rankings.csv'}
                filters={false}
            />
            <div className={teamBoxStyles.team_table_container}>
                <SortableTable
                    records={data.allCurrentElosCsv.nodes}
                    fields={tempFields}
                    plateType={'team'}
                    defaultSort={defaultSort}
                    linkType={'team'}
                    idField={'team'}
                />
            </div>
            <div className={teamStyles.content_container}>
                <h1 className={teamStyles.section_header}>
                    nfelo Power Rankings, NFL Elo Ratings, & Advanced Metrics (ie EPA)
                </h1>
                <h2 className={teamStyles.section_header}>
                    nfelo Power Ratings
                </h2>
                <p className={teamStyles.content_p}>
                    Nfelo is an Elo based power ranking model for the NFL. The table above contains each team's current Elo rating along with a handful of additional measurements of performance like point differential and Expected Points Added (EPA) splits.
                </p>
                <h3 className={teamStyles.section_header}>
                    Elo Rating System Basics
                </h3>
                <p className={teamStyles.content_p}>
                    Elo is a rating system for predicting head-to-head competitions between opponents. Though originally created to measure chess players, it's since been adapted to measure a wide variety of competitions and sports.<br className={teamStyles.content_break}/>
                    All Elo systems start with an initial Elo value for each team (or player in the case of chess). Before each game, the Elo ratings of both teams are compared to create a prediction of the outcome. Once the game is played, the Elo model compares the actual result against its expectations, and updates the Elo ratings for each team according. Pretty simple, right?<br className={teamStyles.content_break}/>
                </p>
                <h3 className={teamStyles.section_header}>
                    Creating an NFL Elo
                </h3>
                <p className={teamStyles.content_p}>
                    In addition to the elegance in their simplicity, Elo rating systems also benefit from their ability to be extended and customized for the competitions they measure. This is exactly what nfelo does. It's Elo for the NFL, hence the name (NFL + Elo = nfelo).<br className={teamStyles.content_break}/>
                    nfelo takes the core Elo framework and adds to it:<br className={teamStyles.content_break}/>
                    <ul>
                        <li>Improved initial ratings derived from win total market signals.</li>
                        <li>A <a className={teamStyles.articleLink} href="https://www.nfeloapp.com/analysis/a-further-exploration-of-home-field-advantage-in-the-nfl/">custom model for Home Field Advantage (HFA)</a> that uses historical</li>
                        <li>A <a className={teamStyles.articleLink} href="https://github.com/greerreNFL/nfeloqb">custom model</a> for predicting a QB's performance.</li>
                        <li><a className={teamStyles.articleLink} href="https://www.nfeloapp.com/analysis/using-market-regression-to-improve-prediction-accuracy-in-the-nfl/">Smart market reversion logic</a> that leverages the predictive power of Vegas spreads while preserving as much non-market signal as possible.</li>
                        <li>Modifications to the core Elo variables to make the formula optimally responsive to weekly game results</li>
                    </ul>
                    The addition of these enhancements has made nfelo one of the internet's most accurate model for NFL sides. In the <a className={teamStyles.articleLink} href="https://www.nfeloapp.com/games/nfl-model-performance/">"Model Performance" section</a>, you can see the model's back-tested performance for each NFL season dating back to 2009.
                </p>
                <h2 className={teamStyles.section_header}>
                    Using Elo ratings for NFL Betting and Analysis
                </h2>
                <p className={teamStyles.content_p}>
                    Since Elo rating systems are not tailored to the NFL out of the box, a little more work needs to be done to make it actionable for different types of NFL betting and analysis. When Elo compares one team's rating to another, its prediction is expressed as a win probability for one side. In the case of nfelo, it's also the home team win probability. Here's how nfelo translates this win probability into different applications.
                </p>
                <h3 className={teamStyles.section_header}>
                    Pick'em and Confidence pools
                </h3>
                <p className={teamStyles.content_p}>
                    Since Pick'em and <a className={teamStyles.articleLink} href="https://www.nfeloapp.com/games/nfl-confidence-picks/">Confidence pools</a> are effectively just a stack rank of who is most likely to win, nfelo is pretty well situated. The model takes the home team win probability and subtracts it from 1 to find the away team win probability. The higher of these two numbers is then taken to represent the overall winner's expected win probability. The confidence pool recommendations are then just a stack rank of winners based on who has the highest probability.
                </p>
                <h3 className={teamStyles.section_header}>
                    Estimating Handicaps and Point Spreads
                </h3>
                <p className={teamStyles.content_p}>
                    Translating win probabilities into an expected winning margin of victory (or spread) is a bit more complex. To do this, nfelo uses a second model built on historical money line odds and spreads to translate a winning probability (ie the money line odds) into a winning margin (ie the spread).<br className={teamStyles.content_break}/>
                    In instances where the model's predicted winning margin and the market spread differ, nfelo uses an <a className={teamStyles.articleLink} href="https://www.nfeloapp.com/analysis/margin-probabilities-from-nfl-spreads/">additional model</a> for measuring how likely a team is to cover the market number. This is the basis for creating an Expected Value (EV) for each game, which are displayed on the <a className={teamStyles.articleLink} href="https://www.nfeloapp.com/games/nfl-ev-bets/">betting card</a> screen.
                </p>
                <h3 className={teamStyles.section_header}>
                    Evaluating Strength of Schedule and Playoff Odds
                </h3>
                <p className={teamStyles.content_p}>
                    A final use of NFL Elo ratings is in measuring strength of schedule, both played and upcoming. Translating Elo ratings into strength of schedule is as easy as calculating the average Elo ratings of the a team's opponent (either played or yet to be played).<br className={teamStyles.content_break}/>
                    Combining Elo ratings and schedules also allows you to calculate Super Bowl and Playoff odds. Comparing the Elo ratings of any two teams produces an expected win probability, which can be used to simulate future outcomes using methods like a Monte Carlo. This functionality hasn't yet been added the nfelo site, but you can expect to see it in the future.
                </p>
                <h3 className={teamStyles.section_header}>
                    Limitations of Elo Ratings in Betting and Analysis
                </h3>
                <p className={teamStyles.content_p}>
                    Elo ratings, while advantageous in many ways, have their limitations in betting. Some of these limitations include:
                    <ul>
                        <li>Reliance on limited information (ie just margin of victory)</li>
                        <li>Constant value for sensitivity to new results</li>
                        <li>Difficulty in considering midseason changes such as trades or injuries</li>
                        <li>Inability to adjust ratings recursively if team's turn out to be much better or worse than expected at time of measurement.</li>
                    </ul>
                    These limitations aren't necessarily unique to NFL Elo Rating systems, and can be mitigated with further extensions and customizations, but they are important to understand.
                </p>
                <h2 className={teamStyles.section_header}>
                    Other Power Rating Metrics
                </h2>
                <p className={teamStyles.content_p}>
                    In addition to NFL Elo ratings, the table above also includes a few other team metrics that can be useful for power ratings.
                </p>
                <h3 className={teamStyles.section_header}>
                    Wins
                </h3>
                <p className={teamStyles.content_p}>
                    Of course, wins are the most important stat, but they're not always the most predictive. Bad breaks in critical situations can turn wins into losses, even if those breaks aren't likely to happen again in the future. For this reason, it can be helpful to compare a team's actual wins against expected wins derived from other metrics. The table shows "Pythagorean Wins", which are based on a point differential equation, "PFF Wins", which use PFF grades to predict how many wins a team should have, and "538 Wins", which is just a sum of FiveThirtyEight's Elo based predictions. These metrics tend to be more predictive of future performance than wins alone and provide context for who has gotten lucky or unlucky.
                </p>
                <h3 className={teamStyles.section_header}>
                    Point Differential
                </h3>
                <p className={teamStyles.content_p}>
                    Point differential is, quite possibly, the simplest metric there is for measuring team performance. Despite this simplicity, it's also one of the most predictive, beating out advanced metrics like DVOA, or Expected Points Added (EPA). In the table, you'll find "Points For", "Points Against", and "Net Points", which is just the total margin of victory.
                </p>
                <h3 className={teamStyles.section_header}>
                    NFL EPA (Expected Points Added)
                </h3>
                <p className={teamStyles.content_p}>
                    EPA, which stands for Expected Points Added, is an advanced metric that has grown in popularity in recent years. It's based on a machine learning model that uses factors like starting field position, time remaining the half, down and distance, hardline, and more to determine how many points an offense is expected to score on their current drive based on their current context. Expected Points Added measures this expected points value at the start and end of each play, which allows us to determine how much value was created or destroyed on any individual play.<br className={teamStyles.content_break}/>
                    Adding up all these values tells us how many points a team produced over or below what we'd expect a league average team to produce in similar situations. Additionally, since EPA assigns value at the individual play level, it allows for a variety of informative aggregations.<br className={teamStyles.content_break}/>
                    In this table, EPA per play is split across offensive and defensive passing and rushing plays. These splits are a great way to determine which teams perform the best in different phases of the game.
                </p>
                <h2 className={teamStyles.section_header}>
                    Frequently Asked Questions
                </h2>
                <h3 className={teamStyles.section_header}>
                    What is Elo in the NFL?
                </h3>
                <p className={teamStyles.content_p}>
                    Elo is a rating system that, in the context of the NFL, evaluates teams by assigning them a numerical rating, ranging from 1000-2000, based on their pregame and postgame performance. After each game, the team's Elo rating is updated according to the result of the game. The maximum number of points a team can gain from winning is determined by a predetermined factor known as K. The average team has an Elo of 1505.
                </p>
                <h3 className={teamStyles.section_header}>
                    What does Elo stand for?
                </h3>
                <p className={teamStyles.content_p}>
                    Elo does not stand for anything. It is actually named after its creator Arpad Elo. Arpad Elo originally created Elo ratings as a method for calculating the relative skill levels of chess players, but it can be extended to calculate the relative ratings of any two-player (or team), zero-sum game.
                </p>
                <h3 className={teamStyles.section_header}>
                    What is an Elo forecast?
                </h3>
                <p className={teamStyles.content_p}>
                    The Elo rating system is a measure of team strength based on head-to-head results, margin of victory and quality of opponent. It is used to predict the probability of one team winning over the other and can also be used to forecast the magnitude of the result. This process of using Elo ratings to create a prediction is known as an Elo forecast.
                </p>
                <h3 className={teamStyles.section_header}>
                    How do you calculate Elo rating?
                </h3>
                <p className={teamStyles.content_p}>
                    The original Elo rating system devised by Arpad Elo calculates Elo using the formula R'a = Ra + Ra. K*(Sa — Ea), where R'a is the new rating, Ra is the previous rating, Ea denotes the expected outcome and SA is the actual outcome of the match. Other models like nfelo, which have adapted Elo ratings to other domains make modifications to this formula.
                </p>
                <h3 className={teamStyles.section_header}>
                    What is the purpose of Elo ratings in NFL predictions?
                </h3>
                <p className={teamStyles.content_p}>
                    Elo ratings provide a numerical representation of team strengths which enables predictions of game outcomes and comparison of teams. It is a team based power rating system, which generally has the same purpose and application of any other NFL power rating system. What sets nfelo, and other model based systems is that they are entirely quantitative, and, as a result, potentially less biased.
                </p>
            </div>
        </div>
    )
}

export default TeamBoxSort